import React, { useState } from "react";
import {
  NotebookText,
  Users,
  Receipt,
  Plane,
  Bed,
  BusFront,
  Car,
  Paperclip,
  Ellipsis,
} from "lucide-react";

import LodgingModal from "../LodgingModal";
import CommuteModal from "../CommuteModal";


const IconButton = ({ icon: Icon, onClick, title, showLabel = false, large = false }) => (
  <button
    onClick={onClick}
    title={title}
    className={`flex flex-col items-center justify-center rounded hover:bg-gray-200 transition p-2 
      ${large ? "space-y-2" : "space-y-1"}`
    }
  >
    <div className={`${large ? "w-8 h-8" : "w-5 h-5"} flex items-center justify-center`}>
      <Icon className={`${large ? "w-8 h-8" : "w-5 h-5"} text-gray-700`} />
    </div>
    {showLabel && (
      <span className={`${large ? "text-sm" : "text-xs"} text-center leading-tight`}>
        {title}
      </span>
    )}
  </button>
);


const TripToolbar = ({
  onOpenNote,
  onOpenMembers,
  onOpenExpenses,
  onOpenFlights,
  onOpenLodging,
  onOpenCommute,
  onOpenRental,
  onOpenAttachments,
}) => {
  const [showOther, setShowOther] = useState(false);

  const handleOtherClick = () => setShowOther(true);
  const handleCloseModal = () => setShowOther(false);

  return (
    <>
      {/* Top toolbar (只保留 5 個 icon + Other) */}
      <div className="flex flex-wrap justify-center gap-3 mb-4 bg-white p-3 rounded-lg shadow">
        <IconButton icon={Plane} onClick={onOpenFlights} title="Flights" />
        <IconButton icon={Bed} onClick={onOpenLodging} title="Lodging" />
        <IconButton icon={Receipt} onClick={onOpenExpenses} title="Expenses" />
        <IconButton icon={NotebookText} onClick={onOpenNote} title="Trip Note" />
        <IconButton icon={Paperclip} onClick={onOpenAttachments} title="Attachments" />
        <IconButton icon={Ellipsis} onClick={handleOtherClick} title="Other" />
      </div>

      {/* Modal */}
      {showOther && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="modal-content max-w-md w-full bg-white rounded-lg p-6 shadow-lg">
            <h2 className="text-lg font-semibold mb-4">More Options</h2>
            <div className="grid grid-cols-3 gap-6">
              <IconButton icon={Plane} onClick={onOpenFlights} title="Flights" showLabel large />
              <IconButton icon={Bed} onClick={onOpenLodging} title="Lodging" showLabel large />
              <IconButton icon={Receipt} onClick={onOpenExpenses} title="Expenses" showLabel large />
              <IconButton icon={NotebookText} onClick={onOpenNote} title="Trip Note" showLabel large />
              <IconButton icon={Paperclip} onClick={onOpenAttachments} title="Attachments" showLabel large />
              <IconButton icon={BusFront} onClick={onOpenCommute} title="Transportation" showLabel large />
              <IconButton icon={Car} onClick={onOpenRental} title="Rental Car" showLabel large />
              <IconButton icon={Users} onClick={onOpenMembers} title="Trip Members" showLabel large />
            </div>
            <div className="flex justify-end mt-6">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TripToolbar;